<template>
  <div class="program-item d-flex justify-content-between">
    <div class="pe-2">
      <div class="program-item__name">
        {{ Program.ProgramName }}
        <span v-if="isLive" class="tag ms-1">NOW</span>
      </div>
      <div>
        {{ formatDateTime(Program.DtStart) }} -
        {{ formatDateTime(Program.DtEnd) }}
      </div>
      <div>{{ Program.ProgramLocation }}</div>
    </div>

    <div class="align-self-center">
      <img
        src="../assets/images/event/icon-arrow-right.svg"
        alt="Arrow right"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgramItemComponent",
  props: {
    Program: Object,
  },
  methods: {
    formatDateTime(date) {
      return new Intl.DateTimeFormat("de-DE", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric"
      }).format(new Date(date));
    },
  },
  computed: {
    isLive() {
      let date = new Date();

      return (
        date >= new Date(this.Program.DtStart) &&
        date <= new Date(this.Program.DtEnd)
      );
    },
  },
};
</script>
